export const sideDrawer = {
  topNavHeight:"50px",
  outerClasses:"rvit-side-nav-drawer"
}



import { cmsasset } from '@kit/utils/Formats'


export const navbar = {

  //optional. if it will shrink on scroll
  scrollShrink: true, //false,

  subitemsRevealDuration: 0,

  //the mergeable classes for the outer fixed wrapper
  outerContainerClassesDesktop: "fbicc-nav-outer",
  outerContainerClassesMobile: "fbicc-nav-outer",

  backgroundColor: "var(--nav-main-color1)",
  shrinkColor:"var(--nav-main-color1)",
  backgroundProperty:"background-color",

  logoWrapperClasses:"fbicc-logo-wrapper",

  hamburgerButtonClasses:"fbicc-hamburger-button",

  //the logo and aria text
  logoSrc:"/cms-static-assets/2026/04/Bidwell-Logo.jpg",
  logoAriaAlt:"FBICC navigation logo",

  desktopLayout:"banner",

  banner: {
    hasRightArea:false,
    hasLeftLogoArea:true,
    navAreaClasses:{ override:"sb sb-v" },
    topAreaClasses:{ override:"sb sb-v sb-greedy" },
    //topAreaClasses:"sb-content-space-between sb-align-2bottom sb-alt2"
  },

  //required
  height: "150px",
  shrinkHeight: "50px",


  padding: "14px",
  shrinkPadding: "5px",

  //optional. The top gap
  topGap: "0px"
    
}
